import {z} from 'zod';
const usPostalCodeRegex = /^\d{5}(-\d{4})?$/;

export const CustomerServiceRequestSchema = z.object({
    tenantUuid: z.string()
        .min(1,"Tenant ID is required")
        .max(50,"Tenant ID must be 50 characters or less")
        .regex( new RegExp(/^[a-zA-Z0-9-_]+$/), "Tenant ID can only include letters numbers, _ and -"),
    requestTypeCode: z.string()
        .min(1,"Request Type Code is required")
        .max(30,"Request Type Code must be 50 characters or less")
        .regex( new RegExp(/^[a-zA-Z0-9-_]+$/), "Request Type Code can only include letters numbers, _ and -"),
    pageSourceTypeCode : z.string()
        .min(1,"Page Source Type Code is required")
        .max(50,"Page Source Type Code must be 50 characters or less")
        .regex( new RegExp(/^[a-zA-Z0-9-_]+$/), "Page Source Type Code can only include letters numbers, _ and -"),
    nameUnknownFlag : z.boolean(),
    firstName: z.string()
        .min(2, "First Name is required.")
        .max(40,"First Name must be 40 characters or less.")
        .regex( new RegExp('^[a-zA-Z]+(?: [a-zA-Z]+)?(?: [IVX]+)?$'), "First Name can only include letters and spaces."),
    lastName: z.string()
        .min(2, "Last Name is required.")
        .max(40,"Last Name must be 40 characters or less.")
        .regex( new RegExp('^[a-zA-Z]+(?: [a-zA-Z]+)?(?: [IVX]+)?$'), "Last Name can only include letters and spaces."),
    primaryEmailAddress: z.string()
        .min(3, "Email is required.")
        .max(320,"Email must be 320 characters or less.")
        .email("Please enter a valid email address."),
    addressLine1 : z.string()
        .min(3, "Street Address is required.")
        .max(300,"Street must be 300 characters or less.")
        .regex( new RegExp('^$|^[a-zA-Z0-9\\s\\-\\.,#]+$'), "Street address can only include letters, spaces, numbers and a few special characters."),
    addressLine2 : z.string()
        .optional(),
    addressCity : z.string()
        .min(3, "City is required.")
        .max(150,"City must be 150 characters or less.")
        .regex( new RegExp('^$|^[a-zA-Z0-9\\s\\-\\.,#]+$'), "City can only include letters, spaces, numbers and a few special characters."),
    addressRegionIsoCode: z.string()
        .min(2,"State is required."),
    addressPostalCode: z.string()
        .regex( new RegExp(usPostalCodeRegex), "If Zip Code is provided, it must be either 5 digit number of zip + 4 in xxxxx-xxxx format."),
    primaryPhone: z.string()
        .min(1,"Phone number is required.")
        .max(13, "Phone number should be in a format of (xxx)xxx-xxxx")
        .regex( new RegExp('^[0-9()-]+$'), "Phone number can only contain numbers, (), and -"),
    preferredContactMethod: z.string()
        .min(1,"Preferred Contact Method is required")
        .max(30,"Preferred Contact Method  must be 50 characters or less")
        .regex( new RegExp(/^[a-zA-Z0-9-_]+$/), "Preferred Contact Method  can only include letters numbers, _ and -"),
    quoteTypeAutoFlag: z.boolean(),
    quoteTypeHomeFlag: z.boolean(),
    quoteTypeHealthFlag : z.boolean(),
    quoteTypeLifeFlag : z.boolean(),
    quoteTypeCycleFlag : z.boolean(),
    quoteTypeBoatFlag : z.boolean(),
    quoteTypeCommercialFlag : z.boolean(),
    quoteTypeOtherFlag: z.boolean(),
    customerComments: z.string(),
    sr22Flag: z.boolean(),
    formErrors: z.string().optional(),
}).refine((data) => data.requestTypeCode != 'QUOTE' ||  data.quoteTypeAutoFlag || data.quoteTypeHomeFlag || data.quoteTypeHealthFlag || data.quoteTypeLifeFlag || data.quoteTypeCycleFlag || data.quoteTypeBoatFlag || data.quoteTypeCommercialFlag || data.quoteTypeOtherFlag, {
    message: "At least one product must be selected from the list below before proceeding.",
    path: ['formErrors'],
})

/*
age: z.coerce.number()
    .int("Age is required to properly quote an accurate price")
    .gt(0, "Age is required to properly quote an accurate price.")
    .min(18, "In most states, you must be 18 to purchase insurance")
    .max(99, "Please enter an age between 18 and 99"),*/
